// Captura del código de partner (?ref= en la URL).
//
// El código se guarda en localStorage al primer contacto y desde ahí viaja a las
// dos puertas de alta que arrancan en el frontend: el formulario de registro (en
// el payload de /auth/register) y los botones de SSO (como ?ref= hacia
// /auth/{google,microsoft}/login, que lo meten en el `state` de OAuth).
//
// PRIMER CONTACTO GANA: si ya hay un código guardado, uno nuevo NO lo pisa. Es la
// política de atribución decidida para el programa — el partner cuyo enlace trajo
// a la persona primero es el que atribuye, aunque después llegue por otro enlace.
//
// Sin expiración a propósito: no hay ventana de cookie que administrar (Pipedrive
// usa 30 días; acá no) porque el código viaja junto con el alta — si el tenant
// nace con el sello, devenga; si nace sin él, no hay partner. Un código viejo en
// localStorage solo importa si esa persona efectivamente se registra, y entonces
// el primer contacto es exactamente lo que se quiere recordar.

const CLAVE = "tf_partner_ref";

// Se llama una vez al montar la app. Lee ?ref= de la URL con la que se llegó
// (landing, /register, /login, cualquiera) y lo guarda si no había nada.
export function capturarRef() {
    try {
        const ref = new URLSearchParams(window.location.search).get("ref");
        if (ref && !localStorage.getItem(CLAVE)) {
            // Se guarda tal cual llegó, sin validar: la forma canónica la decide
            // el backend, y un código roto igual tiene que llegar hasta el sello
            // para quedar registrado como "codigo_invalido" en vez de perderse.
            localStorage.setItem(CLAVE, ref.slice(0, 40));
        }
    } catch {
        // localStorage puede no estar (modo privado antiguo). El alta no se
        // bloquea por la atribución, tampoco acá.
    }
}

// El código guardado, o null. Lo consumen Register (payload) y Login (SSO).
export function refActual() {
    try {
        return localStorage.getItem(CLAVE) || null;
    } catch {
        return null;
    }
}
